import { callGetApi, callPostApi, callPatchApi, callDeleteApi, callPutApi } from 'services/api/apiCallerProxy';
import { assignCreativesApiFactory } from './assignCreativesApiFactory';

export * from './hooks';
export const assignCreativesApi = assignCreativesApiFactory({
    callGetApi,
    callPostApi,
    callPatchApi,
    callDeleteApi,
    callPutApi,
});
